<template>
  <!-- ---------------------------------- 关于我们 ---------------------------------- -->
  <div class="about">
    <!-- ---------------------------------- 顶部导航栏 ---------------------------------- -->
    <Header></Header>
    <!-- ---------------------------------- 海报图 ---------------------------------- -->
    <div v-if="imgList4.length>1">
      <swiper :options="swiperOption">
        <swiper-slide v-for="(item, index) in imgList4" :key="index">
          <!--          <img class="banner" :src="'http://192.168.71.1:8082/jeecg-boot/sys/common/static/'+item.imgUrl" alt="">-->
          <img class="banner" @click="tiaoZhuan(index)" v-lazy="'http://118.89.87.102:8080/jeecg-boot/sys/common/static/'+item.imgUrl" alt="">
          <p style="margin:5% 0;position:absolute;top: 60%; color: #fff;font-size:60px;left: 50%" v-html="item.remarks"></p>
        </swiper-slide>
        <div class="swiper-pagination" slot="pagination"></div>
        <div class="swiper-button-prev" slot="button-prev"></div>
        <div class="swiper-button-next" slot="button-next"></div>
      </swiper>
      <!--如果你需要分页-->
      <div class="swiper-pagination" slot="pagination"></div>
      <!--如果需要前进后退按钮-->
      <div class="swiper-button-next2"></div>
      <div class="swiper-button-prev2"></div>
    </div>
    <div v-else-if="imgList4.length <= 1">
      <div v-for="(item, index) in imgList4" :key="index">
        <!--          <img class="banner" @click="toDetection()" :src="'http://192.168.71.1:8082/jeecg-boot/sys/common/static/'+item.imgUrl" alt="">-->
        <img class="banner" @click="tiaoZhuan(index)" v-lazy="'http://118.89.87.102:8080/jeecg-boot/sys/common/static/'+item.imgUrl" alt="">
        <div class="propk" v-if="item.video">
<!--          <el-popover-->
<!--            placement="top-start"-->
<!--            width="200"-->
<!--            trigger="hover"-->
<!--            :visible-arrow = false-->
<!--          >-->
            <video :src="item.video" frameborder="0" width="500" height="200"></video>
            <img src="../assets/images/bofang.png" slot="reference" width="110px" height="70px"  style="    position: absolute;
    left: 50%;
    top: 30%;"/>
<!--          </el-popover>-->
        </div>
        <p style="margin:5% 0;position:absolute;top: 60%; color: #fff;font-size:60px;left: 50%" v-html="item.remarks"></p>
      </div>
    </div>
    <!-- ---------------------------------- Renaud 蔚诺 ---------------------------------- -->
    <div class="content">
      <!-- 标语 -->
      <div class="slogan">
        <div>蔚然新创·诺守健康</div>
      </div>
      <!-- 插图 -->
      <img class="circular" src="../assets/images/icon/green-circular.png" alt="">
      <!-- 公司简介 -->
      <div class="introduction">
        <h2>Renaud 蔚诺</h2>
        <!-- 公司介绍 -->
        <p class="subtitle" id="gsjj"> 公司简介</p>
        <!-- 横线 -->
        <div class="line"></div>
        <div class="text" style="margin-bottom:50px;">
          Renaud蔚诺成立于2008年，除提供空气净化产品，更进一步研发全球独一无二的健康科技产品。专心致志推出天然智造殖氧系列产品，带给人体新鲜空气之余，更不忘改善人类生活素质。我们现今拥有超过两万个客户，为市民服务已经超过十个年头，2018年我们已正式成为（LBS Group）旗下成员之一。依靠史伟莎母集团的雄厚资源，我们将带来更高质的产品及优质服务。
        </div>
        <!-- 品牌故事 -->
        <p class="subtitle">品牌故事</p>
        <!-- 横线 -->
        <div class="line"></div>
        <!-- WeBegin -->
        <img class="white_font" src="../assets/images/webegin.png" alt="">
        <div class="text">
          Renaud蔚诺品牌矢志为大自然空气优化、净化、活化竭尽所能。原来这一切都是因为来自加拿大的品牌创始人Iannique Renaud的儿子患上呼吸道疾病开始。由于遍寻良方也无法根治这因为空气污染而导致过敏的疾病，于是Iannique用了多年的时间去采购、研究坊间发售的空气净化机，遍寻智造新鲜空气的良方。最后更创立Renaud air品牌，希望能帮助其他因受空气污染而发病的受害者。
        </div>
        <!-- WeThink -->
<!--        <img class="white_font" src="../assets/images/wethink.png" alt="">-->
<!--        &lt;!&ndash; 插图 &ndash;&gt;-->
<!--        <img class="illustrations" src="../assets/images/about-illustrations1.png" alt="">-->
<!--        <div class="text">-->
<!--          Renaud蔚诺品牌利用科学和大自然的资源，专注于高科技钻研、研发不同系列的产品，更有推动减排、绿化的理念。有感于现今社会经济发展急速，代价却是牺牲环境，空气污染问题日益严重，人类连呼吸一口清新空气都成妄想。Renaud蔚诺品牌汇聚全球专才，与拥有多年研发植物净化空气经验的专家，齐心实现净化空气、洁净地球的宏愿。期望通过天然智造殖氧，令室内空气及负离子含量，与大自然森林的新鲜空气及阻止病毒的功能看齐，为人类环境再造新鲜空气，带来新希望。-->
<!--        </div>-->
        <!-- WeCreate -->
        <img class="white_font" src="../assets/images/wecreate.png" alt="">
        <!-- 插图 -->
        <img class="illustrations" src="../assets/images/about-illustrations2.png" alt="">
<!--        <div class="text">-->
<!--          Renaud 蔚诺品牌团队精心擘划，研发以天然植物有效释放天然氧气、净化废气、能进一步保护地球并减少废物的RG系列。独创技术能释放天然负离子，安坐室内即能感受森林释放的清新空气感，而且释放天然负离子数量之巨，对人体血液好，能让城市人保健养生。RG能释放新鲜氧气，减少患上慢性缺氧疾病的风险，亦能真正杀灭或分解空气污染物。-->
<!--        </div>-->
        <div class="text">
          Renaud品牌对于研发团队很有追求。不论是产品测试、效益还是产品的功能及完善度，品牌追求不断优化，矢志专心研发净化、优化空气技术和产品，为消费者排忧解难！
                </div>
                <div class="text">
                  PN系列空气净化机拥用专利纳米技术，先进等离子驱动催化技术PDC Electrode，配合纳米纤维滤网Nanofiber，整合了等离子体和光触媒，提供优秀的空气污染物分解能力，誓要提供最清新洁净空气。
                </div>
                <div class="text">
                 蔚诺品牌研发团队心存初心，不仅要让人类生活更健康、还要让人类延年益寿变得更可能！
                </div>
              </div>
            </div>
            <!-- ---------------------------------- 底部栏 ---------------------------------- -->
            <Footer></Footer>
          </div>
</template>

<script>
  import Header from '@/components/Header'
  import Footer from '@/components/Footer';
  import { swiper, swiperSlide } from "vue-awesome-swiper";
  import "swiper/dist/css/swiper.css";
  import Axios from "axios"

  export default {
    components:{
      Header,
      Footer,
      swiper,
      swiperSlide,
    },
    data () {
      return {
        imgList4: [],
        swiperOption: {
          loop: true,
          autoplay: {
            delay: 3000,
            stopOnLastSlide: false,
            disableOnInteraction: false
          },
          // 显示分页
          pagination: {
            el: ".swiper-pagination",
            clickable: true //允许分页点击跳转
          },
          // 设置点击箭头
          navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev"
          }
        },
      }
    },
    created() {
      this.getImagesUrl();
    },


    methods: {
      
      // banner点击页面跳转
      tiaoZhuan(val){
        var that = this
        if(that.imgList4[val].lujing === null){
          return
        }
        window.location.href = that.imgList4[val].lujing
      },
      getImagesUrl() {
        var that = this;
        // var url = "http://192.168.71.1:8082/jeecg-boot/h5/h5Controller/getBannerImages?location="+96+"&category="+91;
        var url = "http://118.89.87.102:8080/jeecg-boot/h5/h5Controller/getBannerImages?location="+96;
        Axios.get(url).then(res =>{
          if (res.data.success === true) {
            for (let i = 0; i <res.data.result.length; i++) {
              that.imgList4.push({
                lujing: res.data.result[i].backup1,
                imgUrl: res.data.result[i].picUrl,
                remarks: res.data.result[i].remarks,
                video: res.data.result[i].backup2,
              })
            }
          }
        })
      },
    }
  }
</script>

<style lang="less" scoped>
  .propk{
    width: 100%;
    position: absolute;
    top: 50%;
    text-align: center;
  }
  .banner .bfbtn{
    width: 110px;
    height: 70px;
  }
  // ---------------------------- 海报图 ---------------------------------
  .banner{
    width: 100%;
  }
  // ---------------------------- Renaud 蔚诺 ---------------------------------
  // ------------- mobile端样式 -------------
  @media only screen and (max-width: 960px) {     // 屏幕小于960px
    // 标语
    .slogan{
      div{ font-size: 54px;border-left: 6px solid #98A543;border-right: 6px solid #98A543;}
    }
    // 插图
    .circular{position: absolute;top: 8%;right: 8%;}
    // 公司简介
    .introduction{
      // 主标题
      h2{ font-size: 90px;margin-top: 3.5%;}
      // 副标题
      .subtitle{ font-size: 60px;}
      // 横线
      .line{ width: 404px;}
      // 内容
      .text{ width: 77%;font-size: 50px;}
      // 白色字
      .white_font{ width: 560px;}
    }
	}
  // ------------- pc端样式 -------------
  @media only screen and (min-width: 960px) {     // 屏幕大于960px
    // 标语
    .slogan{
      div{ font-size: 44px;font-weight: lighter;border-left: 4px solid #98A543;border-right: 4px solid #98A543;}
    }
    // 插图
    .circular{position: absolute;top: 9%;right: 8%;}
    // 公司简介
    .introduction{
      // 主标题
      h2{ font-size: 80px;}
      // 副标题
      .subtitle{ font-size: 50px;}
      // 横线
      .line{ width: 344px;}
      // 内容
      .text{ width: 67%;font-size: 28px;}
      // 白色字
      .white_font{ width: 510px;}
    }
	}
  .content{
    width: 100%;
    background-color: #ACBD8A;
    position: relative;
    padding-bottom: 10%;
    // 标语
    .slogan{
      width: 100%;
      height: 216px;
      background: url('../assets/images/about-white-bg.png') no-repeat;
      background-size: 100% 100%;
      background-position: center;
      box-sizing: border-box;
      padding: 3% 1.8% 0 0;
      div{
        width: 35%;
        color: #98A543;
        letter-spacing: 12px;
        text-align: center;
        margin: 0 auto;
        padding-left: 10px;
      }
    }
    // 插图
    .circular{
      width: 308px;
    }
    // 公司简介
    .introduction{
      width: 100%;
      // 主标题
      h2{
        color: #1B2D56;
        text-align: center;
        font-family: "等线";
        padding-top: 20px;
      }
      // 副标题
      .subtitle{
        color: #1B2D56;
        letter-spacing: 10px;
        text-align: center;
        margin-bottom: 29px;
      }
      // 横线
      .line{
        border-bottom: 8px solid #1B2D56;
        margin: 0 auto;
      }
      // 内容
      .text{
        color: #1B2D56;
        margin: 0 auto;
        line-height: 2;
        margin-top: 2%;
      }
      // 白色字
      .white_font{
        display: block;
        margin: 0 auto;
        margin-top: 55px;
      }
      // 插图
      .illustrations{
        width: 608px;
        display: block;
        margin: 0 auto;
        margin-top: 49px;
      }
      .recommendPage .swiper-container{
        position: relative;
        width: 100%;
        height: 200px;
        background: pink;
      }
      .recommendPage .swiper-container .swiper-slide{
        width: 100%;
        line-height: 200px;
        background: yellowgreen;
        color: #000;
        font-size: 16px;
        text-align: center;
      }
    }
  }
   img[lazy="loading"] {
	    	width: 18%;
		    height: 18%;
        margin-left: 40%;
        margin-top: 3%;
	}


</style>



// WEBPACK FOOTER //
// src/view/about.vue